"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InCommandRequestPriorityLevels = exports.InCommandRequestPriorityLevel = exports.SeverityLevel = exports.MonitoringSystemType = exports.RawNotificationStatus = exports.TimeUnit = exports.AlertState = void 0;
var AlertState;
(function (AlertState) {
    AlertState["NORMAL"] = "NORMAL";
    AlertState["OFF_NORMAL"] = "OFF_NORMAL";
    AlertState["ACKNOWLEDGED"] = "ACKNOWLEDGED";
})(AlertState = exports.AlertState || (exports.AlertState = {}));
//used for Monitoring System Frequency
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["HOURS"] = "HOURS";
    TimeUnit["MINUTES"] = "MINUTES";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
var RawNotificationStatus;
(function (RawNotificationStatus) {
    RawNotificationStatus["PARSING_FAILED"] = "PARSING_FAILED";
    RawNotificationStatus["ENRICHING_FAILED"] = "ENRICHING_FAILED";
    RawNotificationStatus["ALERT_NOTIFICATION_PARSER_FAILED"] = "ALERT_NOTIFICATION_PARSER_FAILED";
    RawNotificationStatus["CREATION_SUCCESS"] = "CREATION_SUCCESS";
    /** Matched an Ignore keyword of its Monitoring System (heartbeat, test e-mail): kept, no alert created. Was HEARTBEAT until 2026-09-22. */
    RawNotificationStatus["IGNORED"] = "IGNORED";
})(RawNotificationStatus = exports.RawNotificationStatus || (exports.RawNotificationStatus = {}));
//TODO: Remove all Types after ZBX01 in the future
var MonitoringSystemType;
(function (MonitoringSystemType) {
    MonitoringSystemType["BMS"] = "BMS";
    MonitoringSystemType["EPMS"] = "EPMS";
    MonitoringSystemType["BMS-EPMS"] = "BMS-EPMS";
    MonitoringSystemType["ZBX01"] = "ZBX01";
    MonitoringSystemType["SenseAnywhere"] = "SenseAnywhere";
    MonitoringSystemType["ACTIVEPOWERP1"] = "ACTIVEPOWERP1";
    MonitoringSystemType["ACTIVEPOWERP2"] = "ACTIVEPOWERP2";
    MonitoringSystemType["TRIDBMS"] = "TRIDBMS";
    MonitoringSystemType["TRIDBMSSEC"] = "TRIDBMSSEC";
    MonitoringSystemType["MANGO"] = "MANGO";
    MonitoringSystemType["IBX"] = "IBX";
    MonitoringSystemType["BLACKLINE"] = "BLACKLINE";
})(MonitoringSystemType = exports.MonitoringSystemType || (exports.MonitoringSystemType = {}));
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["UNKNOWN"] = 0] = "UNKNOWN";
    SeverityLevel[SeverityLevel["HIGHEST"] = 1] = "HIGHEST";
    SeverityLevel[SeverityLevel["HIGH"] = 2] = "HIGH";
    SeverityLevel[SeverityLevel["MEDIUM"] = 3] = "MEDIUM";
    SeverityLevel[SeverityLevel["LOW"] = 4] = "LOW";
    SeverityLevel[SeverityLevel["LOWEST"] = 5] = "LOWEST";
})(SeverityLevel = exports.SeverityLevel || (exports.SeverityLevel = {}));
var InCommandRequestPriorityLevel;
(function (InCommandRequestPriorityLevel) {
    InCommandRequestPriorityLevel["URGENT"] = "Urgent";
    InCommandRequestPriorityLevel["HIGH"] = "High";
    InCommandRequestPriorityLevel["MEDIUM"] = "Medium";
    InCommandRequestPriorityLevel["LOW"] = "Low";
})(InCommandRequestPriorityLevel = exports.InCommandRequestPriorityLevel || (exports.InCommandRequestPriorityLevel = {}));
exports.InCommandRequestPriorityLevels = [
    InCommandRequestPriorityLevel.URGENT,
    InCommandRequestPriorityLevel.HIGH,
    InCommandRequestPriorityLevel.MEDIUM,
    InCommandRequestPriorityLevel.LOW,
];
//# sourceMappingURL=entities.js.map